import * as React from "react";
import {cx} from "emotion";

import "./enrollment-summary.scss";

import {cs}               from "@Common/react/chain-services";
import {keyed}            from "@Common/react/keyed";
import {UseState}         from "@Common/react/use-state";
import {InformationBadge} from "@Common/ui-components/heavy/common/design2/information-badge/information-badge";

export const EnrollmentSummary = ({subtitle, sections, className}) => cs(
    () => (
        <div {...{
            className: cx("enrollment-summary-9dw", className),

            "xd-qa-type": "card",
            "xd-qa-name": "Enrollment Summary",
        }}>
            <div className="header">
                <div {...{
                    className: "title",
                    "xd-qa-type": "label",
                    "xd-qa-name": "Enrollment Summary Title",
                }}>
                    Enrollment Summary
                </div>
                <div {...{
                    className: "subtitle",
                    "xd-qa-type": "text",
                    "xd-qa-name": "Enrollment Summary Description",
                }}>
                    {subtitle}
                </div>
            </div>

            <div className="sections">
                {sections.map(({title, disclaimer, tooltip, lines}, sectionIndex) => (
                    <div className="section" key={sectionIndex}>
                        {!!title && (
                            <div className="header">
                                <div className="title">
                                    {title}{" "}
                                    {!!tooltip && (
                                        InformationBadge({
                                            getTooltip: () => tooltip,
                                        })
                                    )}
                                </div>
                                <div className="disclaimer">
                                    {disclaimer}
                                </div>
                            </div>
                        )}
                        <div className="lines">
                            {lines?.map(({name, value, valueDisplay, type, subLines}, i) => cs(
                                keyed(i),
                                () => (
                                    !type ? (
                                        <div className="line">
                                            <div {...{
                                                className: "label",
                                                "xd-qa-type": "label",
                                                "xd-qa-name": name,
                                            }}>
                                                {name}
                                            </div>
                                            <div {...{
                                                className: cx("value", valueDisplay?.color && "color-" + valueDisplay.color, valueDisplay?.fontWeight),
                                                "xd-qa-type": "text",
                                                "xd-qa-name": name,
                                            }}>
                                                {value}
                                            </div>
                                        </div>
                                    ) : cs(
                                        ["expanded", (_, next) => UseState({next})],
                                        ({expanded}) => ( // expandable-line
                                            <div className="expandable-line">
                                                <div className="toggle-line" onClick={() => expanded.change(v=>!v)}>
                                                    <div {...{
                                                        className: "label",
                                                        "xd-qa-type": "label",
                                                        "xd-qa-name": name,
                                                    }}>
                                                        {name}
                                                    </div>

                                                    <i className={cx("fa", expanded.value ? "fa-chevron-up" : "fa-chevron-down")}/>
                                                </div>

                                                {expanded.value && (
                                                    <div className="sub-lines">
                                                        {subLines.map(({label, subLabel, value}, i) => cs(
                                                            keyed(i),
                                                            () => (
                                                                <div className="sub-line">
                                                                    <div className="left">
                                                                        <div className="label">
                                                                            {label}
                                                                        </div>
                                                                        <div className="sub-label">
                                                                            {subLabel}
                                                                        </div>
                                                                    </div>
                                                                    <div {...{
                                                                        className: "value",
                                                                        "xd-qa-type": "text",
                                                                        "xd-qa-name": label,
                                                                    }}>
                                                                        {value}
                                                                    </div>
                                                                </div>
                                                            ),
                                                        ))}
                                                    </div>
                                                )}
                                            </div>
                                        ),
                                    )
                                ),
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    ),
);
